





















import {
  BaseStandardModal,
  BasePrimaryButton
} from "@web-components";
import { createComponent } from "@vue/composition-api";
import { useDictionary } from "../views/compositions/useDictionary";
import { UNDER_AGE_LINK } from "@dcc/constants/links";

export default createComponent({
  components: {
    BaseStandardModal,
    BasePrimaryButton
  },
  props: {
    portal: {
      type: String,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary,
      UNDER_AGE_LINK
    };
  }
});
